<template>
  <div
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder spl-scan-modal"
    @click.self="closeModal">
    <div class="spl-modal spl-scan-parcels-modal">
      <div v-if="new_event()" class="spl-modal__label">
        Scan Parcels
      </div>
      <div v-else class="spl-modal__label">
        Update Event {{ update_event_model.Milestone }}
      </div>

      <div class="spl-modal__close" @click="closeModal" />

      <form-label>Timestamp</form-label>
      <form-datepicker
        v-model="update_event_model.Timestamp"
        :max="maxDate()"
        :invalid="$v.update_event_model.Timestamp.$error"
        type="datetime"
        class="spl-scan-modal__timestamp"
        min="2009-01-01"
        @blur="$v.update_event_model.Timestamp.$touch()" />
      <span v-if="$v.update_event_model.Timestamp.$error && !$v.update_event_model.Timestamp.maxValue" class="error">Timestamp required and cannot be more than a day in the future.</span>

      <form-label>Event Type</form-label>
      <form-filtered-select
        ref="eventType"
        v-model="update_event_model.Event_Info_ID"
        class="spl-scan-modal__event-type"
        :options="eventInfoOptions"
        :selected-key="update_event_model.Event_Info_ID"
        :invalid="$v.update_event_model.Event_Info_ID.$error"
        @close="$v.update_event_model.Event_Info_ID.$touch" />
      <br>
      <span v-if="$v.update_event_model.Event_Info_ID.$error" class="error">Event Type required.</span>

      <form-label>Signed by</form-label>
      <form-input v-model="update_event_model.Signed_By" class="spl-scan-modal__signed-by" />

      <form-label>Note</form-label>
      <form-textarea
        v-model="update_event_model.Note"
        class="spl-scan-modal__note"
        placeholder="Please don't fill any personal or subjective information in this field" />
      <br>
      <br>
      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            :disabled="$v.$invalid"
            class="spl-scan-modal__submit"
            @onClick="submitModal">
            Save
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import webApi from '@/webApi'
import Helpers from '@/helpers'
import { mapState } from 'vuex'
import constants from '@/constants'
import moment from 'moment'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'ScanParcelsModal',
  mixins: [Helpers],
  props: {
    selectedRows: {
      type: Array,
      default: () => { return [] }
    },
    updateEvent: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      isVisible: false,
      update_event_model: {
        Timestamp: ''
      }
    }
  },
  validations: {
    update_event_model: {
      Timestamp: {
        required,
        maxValue: (value) => {
          return value < moment().add(constants.SCAN_VALID_DAYS_IN_FUTURE, 'days').toISOString()
        }
      },
      Event_Info_ID: {
        required,
        minValue: minValue(0)
      }
    }
  },
  computed: {
    ...mapState('eventInfo', ['eventInfoOptions'])
  },
  watch: {
    updateEvent: {
      handler: function () {
        const currenTimeStamp = this.formatDate(new Date())
        this.update_event_model = {
          Event_ID: this.updateEvent.event_id ? this.updateEvent.event_id : -1,
          Event_Info_ID: this.updateEvent.event_info_id ? this.updateEvent.event_info_id : 1,
          Milestone: this.updateEvent.milestone,
          Timestamp: this.updateEvent.timestamp ? this.updateEvent.timestamp : currenTimeStamp.substring(0, 10) + ' ' + currenTimeStamp.substring(11, 16),
          Note: this.updateEvent.note,
          Signed_By: this.updateEvent.signed_by
        }
      },
      deep: true
    }
  },
  created () {
    const currenTimeStamp = this.formatDate(new Date())
    window.bus.$on('openScanParcelsModal', this.handleOpenScanParcelsModal)
    if (this.updateEvent) {
      this.update_event_model = {
        Event_ID: this.updateEvent.event_id ? this.updateEvent.event_id : -1,
        Event_Info_ID: this.updateEvent.event_info_id ? this.updateEvent.event_info_id : 1,
        Milestone: this.updateEvent.milestone,
        Timestamp: this.updateEvent.timestamp ? this.updateEvent.timestamp : currenTimeStamp.substring(0, 10) + ' ' + currenTimeStamp.substring(11, 16),
        Note: this.updateEvent.note,
        Signed_By: this.updateEvent.signed_by
      }
    }
  },
  beforeDestroy () {
    window.bus.$off('openScanParcelsModal', this.handleOpenScanParcelsModal)
  },
  methods: {
    handleOpenScanParcelsModal () {
      this.isVisible = true
    },
    new_event () {
      return this.update_event_model.Event_ID <= 0
    },
    // Close the scan window
    closeModal () {
      if (this.$refs.eventType) {
        this.$refs.eventType.reset()
      }
      this.isVisible = false
    },
    //* ******************** Submit the modal ****************
    // Will scan a new event or update an existing one
    submitModal () {
      // Handling of a new scan
      if (this.new_event()) {
        // Get the v-model value

        var parcelIds = ''
        var parcelIdList = []

        // Set the parcel ids
        for (var i in this.selectedRows) {
          if (parcelIds !== '') parcelIds += ','
          parcelIds += this.selectedRows[i].Parcel_ID
          parcelIdList.push(this.selectedRows[i].Parcel_ID)
        }

        var scanParcelsModel = {
          Event_Info_ID: this.update_event_model.Event_Info_ID,
          Timestamp: this.update_event_model.Timestamp,
          Note: this.update_event_model.Note || '',
          Signed_By: this.update_event_model.Signed_By ? this.update_event_model.Signed_By : '',
          Parcel_IDs: parcelIds,
          Parcel_ID_List: parcelIdList
        }

        // Call the server
        webApi.parcel.scan_Parcels(scanParcelsModel)
          .then((response) => {
          // Success
            this.$emit('parcelScanned')
            this.closeModal()
          }).catch((response) => {
          // Failure
            window.bus.$emit('openErrorModal', 'Could not Scan parcels')
          })
      } else {
        // Update an existing event_id
        // Call the server
        webApi.event.update_event({
          Event_ID: this.update_event_model.Event_ID,
          Event_Info_ID: this.update_event_model.Event_Info_ID,
          Timestamp: this.update_event_model.Timestamp,
          Note: this.update_event_model.Note || '',
          Signed_By: this.update_event_model.Signed_By ? this.update_event_model.Signed_By : ''
        }).then((response) => {
          // Success
          this.$emit('event_updated')
          this.closeModal()
        }).catch((response) => {
          // Failure
          window.bus.$emit('openErrorModal', 'Could not Scan parcels')
        })
      }
    },

    // Today is the max date for adding a scan
    maxDate () {
      return this.formatDate(moment().add(constants.SCAN_VALID_DAYS_IN_FUTURE, 'days'), true, 'YYYY-MM-DD HH:MM')
    }
  }
}
</script>

<style lang="scss">
.spl-scan-parcels-modal {
  & .error {
    margin-top: -12px;
    margin-bottom: 8px;
  }
}
</style>
